
module.exports = {
    pumpTypes: [{key:"rotodynamic",name:"Rotodynamic"}, {key:"positiveDisplacement",name:"Positive Displacement"}],
    rotoDynamics: [{key:"centrifugal",name:"Centrifugal"}, {key:"mixedFlow",name:"Mixed Flow"}, {key:"axialFlow",name:"Axial Flow"}],
    centrifugals:
        [
            {key:"singleEntryVolute",name:"Single Entry Volute"},
            {key:"doubleEntryVolute",name:"Double Entry Volute"},
            {key:"twoStageVolute",name:"Two Stage Volute"},
            {key:"multistageRadialSplit",name:"Multistage Radial Split"},
            {key:"multistageAxialSplit",name:"Multistage Axial Split"},
            {key:"multistageBarrelCasing",name:"Multistage Barrel Casing"},
            {key:"singlestageWell",name:"Single Stage Well"},
            {key:"multistageWell",name:"Multistage Well"}
       ],
    mixedFlows: [{key:"volute",name:"Volute"}, {key:"bowl",name:"Bowl"}],
    axialFlows: [{key:"well",name:"Well"}],
    positiveDisplacements: [{key:"rotary",name:"Rotary"}, {key:"reciprocating",name:"Reciprocating"}, {key:"open",name:"Open"}],
    rotarys: [{key:"progressingCavity",name:"Progressing Cavity"}, {key:"slidingVane",name:"Sliding Vane"}, {key:"peristaltic",name:"Peristaltic"}, {key:"screw",name:"Screw"}, {key:"lobe",name:"Lobe"}, {key:"gear",name:"Gear"}],
    reciprocatings: [{key:"diaphragm",name:"Diaphragm"}, {key:"plunger",name:"Plunger"}, {key:"piston",name:"Piston"}],
    opens:[{key:"archimedeanScrew",name:"Archimedean Screw"}]
}